import { render, staticRenderFns } from "./UserProfileDisplayLab.vue?vue&type=template&id=34a778ff&scoped=true"
import script from "./UserProfileDisplayLab.vue?vue&type=script&lang=js"
export * from "./UserProfileDisplayLab.vue?vue&type=script&lang=js"
import style0 from "./UserProfileDisplayLab.vue?vue&type=style&index=0&id=34a778ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a778ff",
  null
  
)

export default component.exports